export const APP_NAME = 'Market Data and Investments Explorer';
export const APP_NAME_BREADCRUMB = 'Market Data';
export const DASH = '—';
